// "use client"
// import { useState, useEffect } from "react"
// import { Link } from "react-router-dom"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// import {
//   faBookOpen,
//   faSearch,
//   faFilter,
//   faUser,
//   faCalendarAlt,
//   faCreditCard,
//   faCheckCircle,
//   faTimesCircle,
//   faClock,
//   faChevronDown,
//   faInr,
// } from "@fortawesome/free-solid-svg-icons"
// import { toast } from "react-toastify"
// import Swal from "sweetalert2"
// import { baseUrl } from "../../config/baseUrl"
// import moment from "moment/moment"

// export default function LibraryBookingList() {
//   const [libraryData, setLibraryData] = useState([])
//   const [bookings, setBookings] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [statusFilter, setStatusFilter] = useState("")
//   const [paymentMethodFilter, setPaymentMethodFilter] = useState("")
//   const [slot, setSlot] = useState("")
//   const [slotFilter, setSlotFilter] = useState("")
//   const [expiry, setExpiry] = useState("")
//   const [expiryFilter, setExpiryFilter] = useState("")
//   const [startDate, setStartDate] = useState("")
//   const [endDate, setEndDate] = useState("")
//   const [currentPage, setCurrentPage] = useState(1)
//   const [totalBookings, setTotalBookings] = useState(0)
//   const [totalPages, setTotalPages] = useState(1)
//   const [bookingsPerPage] = useState(10)
//   const userDetails = JSON.parse(localStorage.getItem("user"))

//   useEffect(() => {
//     if (userDetails?._id) {
//       fetchBookings()
//     }
//   }, [currentPage, searchTerm, statusFilter, paymentMethodFilter, startDate, endDate, slotFilter, expiryFilter])

//   const buildApiUrl = () => {
//     const params = new URLSearchParams()

//     if (startDate) params.append("startDate", startDate)
//     if (endDate) params.append("endDate", endDate)
//     if (paymentMethodFilter) params.append("paymentMethod", paymentMethodFilter)
//     if (statusFilter) params.append("status", statusFilter)
//     if (currentPage) params.append("page", currentPage.toString())
//     if (slotFilter) params.append("slot", slotFilter)
//     if (expiryFilter) params.append("expiry", expiryFilter)
//     const queryString = params.toString()
//     return `${baseUrl}/owner/booking/${userDetails?._id}${queryString ? `?${queryString}` : ""}`
//   }

//   const fetchBookings = async () => {
//     try {
//       setLoading(true)
//       const apiUrl = buildApiUrl()

//       const response = await fetch(apiUrl, {
//         method: "GET",
//         headers: {
//           Authorization: localStorage.getItem("token"),
//         },
//       })

//       const data = await response.json()
//       if (data.status) {
//         setLibraryData(data?.data)
//         let fetchedBookings = data.data.bookings || []

//         // Apply client-side search filter for user name/email
//         if (searchTerm) {
//           fetchedBookings = fetchedBookings.filter(
//             (booking) =>
//               booking.userId?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//               booking.userId?.email?.toLowerCase().includes(searchTerm.toLowerCase()),
//           )
//         }

//         setBookings(fetchedBookings)
//         setSlot(data.data?.library?.slots || "")
//         setTotalBookings(data.data.totalCount || 0)
//         setTotalPages(data.data.totalPages || 1)
//       } else {
//         toast.error(data.message || "Failed to fetch bookings")
//         setBookings([])
//       }
//     } catch (error) {
//       console.error("Error fetching bookings:", error)
//       toast.error("Failed to fetch bookings")
//       setBookings([])
//     } finally {
//       setLoading(false)
//     }
//   }

//   const handleStatusChange = async (bookingId, newStatus) => {
//     const result = await Swal.fire({
//       title: "Are you sure?",
//       text: `Do you want to change status to ${newStatus}?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: `Yes, change to ${newStatus}!`,
//     })

//     if (result.isConfirmed) {
//       try {
//         const response = await fetch(`${baseUrl}/library-booking/update-status/${bookingId}`, {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: localStorage.getItem("token"),
//           },
//           body: JSON.stringify({ status: newStatus }),
//         })

//         const data = await response.json()
//         if (data.status) {
//           // Update local state immediately
//           setBookings((prevBookings) =>
//             prevBookings.map((booking) => (booking._id === bookingId ? { ...booking, status: newStatus } : booking)),
//           )
//           toast.success(`Status updated to ${newStatus} successfully`)
//         } else {
//           toast.error(data.message || "Failed to update status")
//         }
//       } catch (error) {
//         console.error("Error updating status:", error)
//         toast.error("Failed to update status")
//       }
//     }
//   }

//   const getStatusBadge = (status, bookingId) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: faClock, text: "Pending" },
//       confirmed: { color: "success", icon: faCheckCircle, text: "Confirmed" },
//       cancelled: { color: "danger", icon: faTimesCircle, text: "Cancelled" },
//       // completed: { color: "info", icon: faCheckCircle, text: "Completed" },
//     }

//     const config = statusConfig[status] || statusConfig.pending

//     // Get available status options (exclude current status)
//     const availableStatuses = [
//       { value: "pending", label: "Pending", icon: faClock },
//       { value: "confirmed", label: "Confirmed", icon: faCheckCircle },
//       { value: "cancelled", label: "Cancelled", icon: faTimesCircle },
//       // { value: "completed", label: "Completed", icon: faCheckCircle },
//     ].filter((s) => s.value !== status)

//     return (
//       <div className="dropdown">
//         <span
//           className={`badge bg-${config.color} d-flex align-items-center gap-1 dropdown-toggle cursor-pointer`}
//           data-bs-toggle="dropdown"
//           aria-expanded="false"
//           style={{ cursor: "pointer" }}
//         >
//           <FontAwesomeIcon icon={config.icon} size="sm" />
//           {config.text}
//           <FontAwesomeIcon icon={faChevronDown} size="xs" />
//         </span>
//         <ul className="dropdown-menu">
//           {availableStatuses.map((statusOption) => (
//             <li key={statusOption.value}>
//               <button
//                 className={`dropdown-item ${statusOption.value === "cancelled" ? "text-danger" : ""}`}
//                 onClick={() => handleStatusChange(bookingId, statusOption.value)}
//               >
//                 <FontAwesomeIcon icon={statusOption.icon} className="me-2" />
//                 {statusOption.label}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>
//     )
//   }

//   const getPaymentMethodBadge = (method) => {
//     return (
//       <span className={`badge ${method === "online" ? "bg-primary" : "bg-secondary"}`}>
//         <FontAwesomeIcon icon={faCreditCard} className="me-1" />
//         {method === "online" ? "Online" : "Offline"}
//       </span>
//     )
//   }

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     })
//   }

//   const formatDateTime = (dateString) => {
//     return new Date(dateString).toLocaleString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     })
//   }

//   const handleClearFilters = () => {
//     setSearchTerm("")
//     setStatusFilter("")
//     setPaymentMethodFilter("")
//     setStartDate("")
//     setEndDate("")
//     setSlotFilter("")
//     setCurrentPage(1)
//     setExpiryFilter("")
//   }

//   const paginate = (pageNumber) => setCurrentPage(pageNumber)
//   const getExpiringInText = (endDate) => {
//     const now = moment();
//     const end = moment(endDate);

//     if (end.isBefore(now)) {
//       return "Expired";
//     }

//     return `${end.fromNow(true)} left`;
//   };

//   return (
//     <>
//        <section className="main-sec">
//       <div className="container-fluid">
//         {/* Header */}
//         <div className="row">
//           <div className="col-lg-6">
//             <div className="dashboard-title">
//               <h4 className="dash-head">
//                 <FontAwesomeIcon icon={faBookOpen} className="me-2" />
//                 {userDetails?.libraryName}
//               </h4>
//             </div>
//             <nav aria-label="breadcrumb" className="custom-bredcump">
//               <ol className="breadcrumb">
//                 <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
//                 <li className="breadcrumb-item active" aria-current="page">Library Bookings</li>
//               </ol>
//             </nav>
//           </div>
//         </div>

//         {/* Summary Cards */}
//         <div className="row mb-3">
//           <div className="col-lg-12 d-flex justify-content-between align-items-center">
//             <h5>Bookings List ({bookings.length} of {totalBookings})</h5>
//             <div className="text-end">
//               <h6>Total Amount (<FontAwesomeIcon icon={faInr} /> {libraryData?.totalAmount}/-)</h6>
//               <h6>Admin Commission (<FontAwesomeIcon icon={faInr} /> {(Number(libraryData?.totalCommission || 0)).toFixed(2)}/-)</h6>
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="row responsive-search-filter mb-3 gx-2 gy-3 align-items-center">
//           <div className="col-12 col-md-6 col-lg-3">
//             <div className="position-relative">
//               <FontAwesomeIcon icon={faSearch} className="responsive-search-icon" />
//               <input
//                 type="text"
//                 className="form-control responsive-search-input ps-5"
//                 placeholder="Search by user name or email..."
//                 value={searchTerm}
//                 onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage?.(1); }}
//               />
//             </div>
//           </div>

//           <div className="col-6 col-md-3 col-lg-2">
//             <input type="date" className="form-control" value={startDate} onChange={(e) => { setStartDate(e.target.value); setCurrentPage?.(1); }} />
//           </div>
//           <div className="col-6 col-md-3 col-lg-2">
//             <input type="date" className="form-control" value={endDate} onChange={(e) => { setEndDate(e.target.value); setCurrentPage?.(1); }} />
//           </div>

//           <div className="col-6 col-md-3 col-lg-2">
//             <select className="form-select responsive-status-filter small-dropdown" value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage?.(1); }}>
//               <option value="">All Status</option>
//               <option value="pending">Pending</option>
//               <option value="confirmed">Confirmed</option>
//               <option value="cancelled">Cancelled</option>
//             </select>
//           </div>

//           <div className="col-6 col-md-3 col-lg-2">
//             <select className="form-select responsive-payment-filter small-dropdown" value={paymentMethodFilter} onChange={(e) => { setPaymentMethodFilter(e.target.value); setCurrentPage?.(1); }}>
//               <option value="">All Methods</option>
//               <option value="online">Online</option>
//               <option value="offline">Offline</option>
//             </select>
//           </div>

//           <div className="col-6 col-md-3 col-lg-2">
//             <select className="form-select responsive-slot-filter small-dropdown" value={slotFilter} onChange={(e) => { setSlotFilter(e.target.value); setCurrentPage?.(1); }}>
//               <option value="">All Slots</option>
//               {slot.map((s, idx) => <option key={idx} value={s._id}>{s.slotId}</option>)}
//             </select>
//           </div>

//           <div className="col-6 col-md-3 col-lg-2">
//             <select className="form-select responsive-expiry-filter small-dropdown" value={expiryFilter} onChange={(e) => { setExpiryFilter(e.target.value); setCurrentPage?.(1); }}>
//               <option value="">Expiring In (days)</option>
//               {[1,2,3,4,5].map(d => <option key={d} value={d}>{d}</option>)}
//             </select>
//           </div>

//           <div className="col-12 col-md-6 col-lg-1">
//             <button className="btn btn-secondary w-100 d-flex justify-content-center" onClick={handleClearFilters}>
//               <FontAwesomeIcon icon={faFilter} className="me-1" /> Clear
//             </button>
//           </div>
//         </div>

//         {/* Active Filters Display */}
//         {(searchTerm || statusFilter || paymentMethodFilter || startDate || endDate) && (
//           <div className="active-filters mb-3">
//             <small className="text-muted">Active Filters:</small>
//             {searchTerm && <span className="badge bg-light text-dark me-1">Search: {searchTerm}</span>}
//             {statusFilter && <span className="badge bg-light text-dark me-1">Status: {statusFilter}</span>}
//             {paymentMethodFilter && <span className="badge bg-light text-dark me-1">Payment: {paymentMethodFilter}</span>}
//             {startDate && <span className="badge bg-light text-dark me-1">From: {moment(startDate).format("MMM DD, YYYY")}</span>}
//             {endDate && <span className="badge bg-light text-dark me-1">To: {moment(endDate).format("MMM DD, YYYY")}</span>}
//           </div>
//         )}

//         {/* Table */}
//         <div className="table-responsive custom-table">
//           <table className="table table-hover align-middle text-nowrap">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>User Details</th>
//                 <th>Period</th>
//                 <th>Booking Date</th>
//                 <th>Expiring In</th>
//                 <th>Payment</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 <tr>
//                   <td colSpan="8" className="loading-spinner">
//                     <div className="d-flex flex-column align-items-center justify-content-center py-4">
//                       <div className="spinner-border text-primary mb-2" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                       <p className="mt-2 mb-0 fw-medium">Loading bookings...</p>
//                     </div>
//                   </td>
//                 </tr>
//               ) : bookings.length === 0 ? (
//                 <tr>
//                   <td colSpan="8" className="empty-state text-center py-4">
//                     <FontAwesomeIcon icon={faBookOpen} size="3x" className="text-muted mb-3" />
//                     <h4>No Bookings Found!</h4>
//                     <p className="text-muted">
//                       {searchTerm || statusFilter || paymentMethodFilter || startDate || endDate
//                         ? "Try adjusting your search or filter criteria"
//                         : "No library bookings available at the moment"}
//                     </p>
//                   </td>
//                 </tr>
//               ) : (
//                 bookings.map((booking, i) => (
//                   <tr key={booking._id}>
//                     <td>{(currentPage - 1) * bookingsPerPage + i + 1}</td>
//                     <td>
//                       <div className="user-info">
//                         <div className="fw-medium text-primary">
//                           <Link to={`/student/${booking._id}`}>
//                             <FontAwesomeIcon icon={faUser} className="me-1" />
//                             {booking.userId?.name || "N/A"}
//                           </Link>
//                         </div>
//                         <small className="text-muted d-block">{booking.userId?.email || "N/A"}</small>
//                         <small className="text-muted d-block">ID: {booking.bookingId || "N/A"}</small>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="period-info">
//                         <div className="fw-medium">{moment(booking.startDate).format("MMM DD, YYYY")}</div>
//                         <small className="text-muted">to</small>
//                         <div className="fw-medium">{moment(booking.endDate).format("MMM DD, YYYY")}</div>
//                         <small className="text-info d-block">{booking.fromTime} - {booking.toTime}</small>
//                       </div>
//                     </td>
//                     <td>
//                       <FontAwesomeIcon icon={faCalendarAlt} className="me-1 text-muted" />
//                       {moment(booking.createdAt).format("lll")}
//                     </td>
//                     <td>
//                       <span className={moment(booking.endDate).isBefore(moment())
//                         ? "text-danger fw-semibold"
//                         : "text-warning fw-semibold"
//                       }>
//                         {getExpiringInText(booking.endDate)}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="payment-info">
//                         {getPaymentMethodBadge(booking.paymentMethod)}
//                         {booking.amount > 0 && (
//                           <div className="mt-1">
//                             <small className="text-success fw-bold">₹{booking.amount}</small>
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                     <td>{getStatusBadge(booking.status, booking._id)}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div className="pagination-container">
//             <nav aria-label="Bookings pagination">
//               <ul className="pagination justify-content-center">
//                 {/* Pagination logic here... */}
//               </ul>
//             </nav>
//             <div className="text-center mt-2">
//               <small className="text-muted">
//                 Showing page {currentPage} of {totalPages} ({bookings.length} of {totalBookings} bookings)
//               </small>
//             </div>
//           </div>
//         )}

//       </div>
//     </section>

//       <style>
//         {`
//           .stats-cards {
//             display: flex;
//             gap: 1rem;
//           }

//           .stat-card {
//             background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//             color: white;
//             padding: 1rem;
//             border-radius: 8px;
//             text-align: center;
//             min-width: 100px;
//           }

//           .stat-number {
//             font-size: 1.5rem;
//             font-weight: bold;
//             margin-bottom: 0.25rem;
//           }

//           .stat-label {
//             font-size: 0.8rem;
//             opacity: 0.9;
//           }

//           .user-info {
//             display: flex;
//             flex-direction: column;
//           }

//           .library-name {
//             font-weight: 500;
//             color: #495057;
//           }

//           .booking-date {
//             display: flex;
//             align-items: center;
//             font-weight: 500;
//           }

//           .payment-info {
//             display: flex;
//             flex-direction: column;
//             gap: 0.25rem;
//           }

//           .period-info {
//             display: flex;
//             flex-direction: column;
//             gap: 0.125rem;
//           }

//           .responsive-search-box .responsive-search-icon {
//             position: absolute;
//             left: 15px;
//             top: 50%;
//             transform: translateY(-50%);
//             color: #6c757d;
//             z-index: 2;
//           }

//           .responsive-search-input {
//             padding-left: 2.5rem !important;
//           }

//           .loading-spinner {
//             text-align: center;
//             padding: 3rem 0;
//           }

//           .empty-state {
//             text-align: center;
//             padding: 3rem 0;
//           }

//           .pagination-container {
//             margin-top: 2rem;
//             padding-top: 1rem;
//             border-top: 1px solid #dee2e6;
//           }

//           .active-filters {
//             padding: 0.5rem;
//             background-color: #f8f9fa;
//             border-radius: 0.375rem;
//             border: 1px solid #dee2e6;
//           }

//           .badge {
//             font-size: 14px;
//             font-weight: 500;
//             padding: 0.375rem 0.75rem;
//           }

//           .badge.dropdown-toggle {
//             transition: all 0.2s ease;
//           }

//           .badge.dropdown-toggle:hover {
//             transform: translateY(-1px);
//             box-shadow: 0 2px 4px rgba(0,0,0,0.1);
//           }

//           .table th {
//             background-color: #f8f9fa;
//             font-weight: 600;
//             border-bottom: 2px solid #dee2e6;
//           }

//           .table td {
//             vertical-align: middle;
//             padding: 1rem 0.75rem;
//           }

//           .table tbody tr:hover {
//             background-color: #f8f9fa;
//           }

//           .cursor-pointer {
//             cursor: pointer;
//           }

//           .dropdown-menu {
//             border: 1px solid #dee2e6;
//             box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
//           }

//           .dropdown-item:hover {
//             background-color: #f8f9fa;
//           }

//           @media (max-width: 576px) {
//             .responsive-search-filter .form-select,
//             .responsive-search-filter .form-control,
//             .responsive-clear-btn {
//               font-size: 0.9rem;
//             }
//           }
//             @media (max-width: 768px) {
//   .custom-table .table {
//     font-size: 0.85rem;
//     white-space: nowrap;
//   }

//   .table td,
//   .table th {
//     padding: 0.5rem;
//   }

//   .user-info small {
//     font-size: 0.75rem;
//   }

//   .period-info {
//     font-size: 0.75rem;
//   }

//   .payment-info small {
//     font-size: 0.75rem;
//   }

//   .table-responsive {
//     overflow-x: auto;
//   }
// }

//         `}
//       </style>
//     </>
//   )
// }

"use client";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faFilter,
  faUser,
  faCreditCard,
  faCheckCircle,
  faTimesCircle,
  faClock,
  faChevronDown,
  faExclamationTriangle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { baseUrl } from "../../config/baseUrl";
import moment from "moment/moment";

export default function LibraryBookingList() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  const [slot, setSlot] = useState([]);
  const [slotFilter, setSlotFilter] = useState("");
  const [expiryFilter, setExpiryFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalBookings, setTotalBookings] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [bookingsPerPage] = useState(10);
  const [seatModalBooking, setSeatModalBooking] = useState(null);
  const [seatMapData, setSeatMapData] = useState(null);
  const [seatMapLoading, setSeatMapLoading] = useState(false);
  const [seatMapError, setSeatMapError] = useState("");
  const [seatSaving, setSeatSaving] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (userDetails?._id) {
      fetchBookings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    searchTerm,
    statusFilter,
    paymentMethodFilter,
    startDate,
    endDate,
    slotFilter,
    expiryFilter,
  ]);

  const buildApiUrl = () => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (paymentMethodFilter)
      params.append("paymentMethod", paymentMethodFilter);
    if (statusFilter) params.append("status", statusFilter);
    if (currentPage) params.append("page", currentPage.toString());
    if (slotFilter) params.append("slot", slotFilter);
    if (expiryFilter) params.append("expiry", expiryFilter);

    const queryString = params.toString();
    return `${baseUrl}/owner/booking/${userDetails?._id}${queryString ? `?${queryString}` : ""
      }`;
  };

  const fetchBookings = async () => {
    try {
      setLoading(true);
      const apiUrl = buildApiUrl();

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      const data = await response.json();
      if (data.status) {
        let fetchedBookings = data.data.bookings || [];

        // Apply client-side search filter for user name/email
        if (searchTerm) {
          fetchedBookings = fetchedBookings.filter(
            (booking) =>
              booking.userId?.name
                ?.toLowerCase()
                .includes(searchTerm.toLowerCase()) ||
              booking.userId?.email
                ?.toLowerCase()
                .includes(searchTerm.toLowerCase())
          );
        }

        setBookings(fetchedBookings);
        setSlot(data.data?.slotList || data.data?.library?.slots || []);
        setTotalBookings(data.data.totalCount || 0);
        setTotalPages(data.data.totalPages || 1);
      } else {
        toast.error(data.message || "Failed to fetch bookings");
        setBookings([]);
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      toast.error("Failed to fetch bookings");
      setBookings([]);
    } finally {
      setLoading(false);
    }
  };

  const normalizeSeatNumber = (value) => {
    const parsedValue = Number(value);
    return Number.isInteger(parsedValue) && parsedValue > 0
      ? parsedValue
      : null;
  };

  const syncBookingInState = (bookingId, updates) => {
    setBookings((prevBookings) =>
      prevBookings.map((booking) =>
        booking._id === bookingId ? { ...booking, ...updates } : booking
      )
    );

    setSeatModalBooking((prevBooking) =>
      prevBooking && prevBooking._id === bookingId
        ? { ...prevBooking, ...updates }
        : prevBooking
    );
  };

  const updateBookingRequest = async (bookingId, payload) => {
    const response = await fetch(
      `${baseUrl}/library-booking/update-status/${bookingId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!data.status) {
      throw new Error(data.message || "Update failed");
    }

    return data;
  };

  const getBookingSlotId = (booking) =>
    booking?.slotId?._id || booking?.slotId || "";

  const getBookingSlotMeta = (booking) => {
    const bookingSlotId = getBookingSlotId(booking);

    if (!bookingSlotId) {
      return null;
    }

    const slotFromBooking =
      booking?.slotId && typeof booking.slotId === "object"
        ? booking.slotId
        : slot.find((slotItem) => slotItem._id === bookingSlotId);

    return slotFromBooking
      ? {
        _id: slotFromBooking._id || bookingSlotId,
        slot_name: slotFromBooking.slot_name || slotFromBooking.slotId || "",
        numberOfSeats:
          Number(slotFromBooking.numberOfSeats) || Number(slotFromBooking.totalSeats) || 0,
        is_mearge: Boolean(slotFromBooking.is_mearge),
      }
      : null;
  };

  const normalizeSeatMapPayload = (payload, booking) => {
    if (!Array.isArray(payload)) {
      return payload;
    }

    const normalizedSeats = payload
      .map((seat) => {
        const seatNumber = normalizeSeatNumber(seat?.seatNo);

        if (!seatNumber) {
          return null;
        }

        const seatStatus = String(seat?.status || "").toLowerCase();
        const isAssigned =
          seatStatus === "occupied" ||
          seatStatus === "assigned" ||
          seatStatus === "booked";

        return {
          seatNo: seatNumber,
          isAssigned,
          occupiedBy: isAssigned
            ? {
              bookedTime: seat?.bookedTime || null,
            }
            : null,
        };
      })
      .filter(Boolean);

    return {
      bookingId: booking?._id,
      selectedSeatNo: normalizeSeatNumber(booking?.seatNo),
      totalSeats: normalizedSeats.length,
      assignedSeats: normalizedSeats
        .filter((seat) => seat.isAssigned)
        .map((seat) => seat.seatNo),
      availableSeats: normalizedSeats
        .filter((seat) => !seat.isAssigned)
        .map((seat) => seat.seatNo),
      slot: getBookingSlotMeta(booking),
      seats: normalizedSeats,
    };
  };

  const fetchSeatMapRequest = async (booking) => {
    const slotId = getBookingSlotId(booking);

    if (!slotId || !booking?._id) {
      throw new Error("Slot information not available for this booking");
    }

    const params = new URLSearchParams({
      slotId,
      bookingId: booking._id,
      startDate: moment(booking.startDate).format("YYYY-MM-DD"),
      endDate: moment(booking.endDate).format("YYYY-MM-DD"),
    });

    const response = await fetch(
      `${baseUrl}/library-booking/seat-map?${params.toString()}`,
      {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      }
    );

    const data = await response.json();

    if (!data.status) {
      throw new Error(data.message || "Failed to load seat map");
    }

    return normalizeSeatMapPayload(data.data, booking);
  };

  const assignSeatRequest = async (bookingId, seatNo) => {
    const data = await updateBookingRequest(bookingId, {
      seatNo,
      status: "confirmed",
    });

    return data.data;
  };

  const handleOpenSeatModal = async (booking) => {
    setSeatModalBooking(booking);
    setSeatMapData(null);
    setSeatMapError("");
    setSeatMapLoading(true);

    try {
      const seatMap = await fetchSeatMapRequest(booking);
      setSeatMapData(seatMap);
      syncBookingInState(booking._id, {
        seatNo: seatMap.selectedSeatNo || booking.seatNo,
        ...(seatMap.slot ? { slotId: seatMap.slot } : {}),
      });
    } catch (error) {
      setSeatMapError(error.message || "Failed to load seats");
    } finally {
      setSeatMapLoading(false);
    }
  };

  const handleCloseSeatModal = () => {
    if (seatSaving) {
      return;
    }

    setSeatModalBooking(null);
    setSeatMapData(null);
    setSeatMapError("");
  };

  const handleSeatAssign = async (seatNumber) => {
    if (!seatModalBooking) {
      return;
    }

    const currentBooking = seatModalBooking;
    const previousSeatNumber = currentBooking?.seatNo ?? "";

    syncBookingInState(currentBooking._id, { seatNo: seatNumber });
    setSeatMapData((prevSeatMap) =>
      prevSeatMap
        ? {
          ...prevSeatMap,
          selectedSeatNo: seatNumber,
        }
        : prevSeatMap
    );

    if (currentBooking.status !== "confirmed") {
      toast.success(`Seat ${seatNumber} selected`);
      handleCloseSeatModal();
      return;
    }

    try {
      setSeatSaving(true);
      const data = await assignSeatRequest(currentBooking._id, seatNumber);
      syncBookingInState(currentBooking._id, {
        seatNo: data.booking?.seatNo || seatNumber,
        ...(data.booking?.slotId ? { slotId: data.booking.slotId } : {}),
      });
      toast.success(`Seat ${seatNumber} assigned successfully`);
      setSeatModalBooking(null);
      setSeatMapData(null);
      setSeatMapError("");
    } catch (error) {
      syncBookingInState(currentBooking._id, { seatNo: previousSeatNumber });
      toast.error(error.message || "Failed to assign seat");
    } finally {
      setSeatSaving(false);
    }
  };

  const handleStatusChange = async (bookingId, newStatus, booking) => {
    const isConfirmStatus = newStatus === "confirmed";

    const seatInput = normalizeSeatNumber(booking?.seatNo);

    // if (isConfirmStatus) {
    //   if (!seatInput) {
    //     toast.error("Please select a valid seat first!");
    //     return;
    //   }
    // }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to change status to ${newStatus}? ${isConfirmStatus ? 'with Seat No: ' + seatInput : ''}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${newStatus} it!`,
    });

    if (result.isConfirmed) {
      const requestPayload = {
        status: newStatus,
        ...(isConfirmStatus ? { seatNo: seatInput } : {}),
      };

      try {
        const data = await updateBookingRequest(bookingId, requestPayload);
        syncBookingInState(bookingId, {
          status: newStatus,
          seatNo: data?.data?.seatNo ?? booking?.seatNo,
          ...(data?.data?.slotId ? { slotId: data.data.slotId } : {}),
        });
        toast.success(`Booking ${newStatus} successfully`);
      } catch (error) {
        toast.error(error.message || "Server error while updating status");
      }
    }
  };


  const getStatusBadge = (status, bookingId, booking) => {
    const statusConfig = {
      pending: { color: "warning", icon: faClock, text: "Pending" },
      confirmed: { color: "success", icon: faCheckCircle, text: "Confirmed" },
      cancelled: { color: "danger", icon: faTimesCircle, text: "Cancelled" },
    };

    const config = statusConfig[status] || statusConfig.pending;

    // Get available status options (exclude current status)
    const availableStatuses = [
      { value: "pending", label: "Pending", icon: faClock },
      { value: "confirmed", label: "Confirmed", icon: faCheckCircle },
      { value: "cancelled", label: "Cancelled", icon: faTimesCircle },
    ].filter((s) => s.value !== status);

    return (
      <div className="dropdown">
        <span
          className={`status-badge status-${config.color} dropdown-toggle`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <FontAwesomeIcon icon={config.icon} size="sm" />
          <span className="status-text">{config.text}</span>
          <FontAwesomeIcon icon={faChevronDown} size="xs" />
        </span>
        <ul className="dropdown-menu dropdown-menu-end">
          {availableStatuses.map((statusOption) => (
            <li key={statusOption.value}>
              <button
                className={`dropdown-item ${statusOption.value === "cancelled" ? "text-danger" : ""
                  }`}
                onClick={() =>
                  handleStatusChange(bookingId, statusOption.value, booking)
                }
              >
                <FontAwesomeIcon icon={statusOption.icon} className="me-2" />
                {statusOption.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const getPaymentMethodBadge = (method) => {
    return (
      <span
        className={`payment-badge ${method === "online" ? "payment-online" : "payment-offline"
          }`}
      >
        <FontAwesomeIcon icon={faCreditCard} size="sm" />
        <span className="payment-text">
          {method === "online" ? "Online" : "Offline"}
        </span>
      </span>
    );
  };

  const handleClearFilters = () => {
    setSearchTerm("");
    setStatusFilter("");
    setPaymentMethodFilter("");
    setStartDate("");
    setEndDate("");
    setSlotFilter("");
    setCurrentPage(1);
    setExpiryFilter("");
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getExpiringInText = (endDate) => {
    const now = moment();
    const end = moment(endDate);

    if (end.isBefore(now)) {
      return { text: "Expired", type: "expired", days: 0 };
    }

    const diffDays = end.diff(now, "days");

    if (diffDays <= 30) {
      return {
        text: `${diffDays} day${diffDays !== 1 ? "s" : ""} `,
        type: diffDays <= 7 ? "critical" : "warning",
        days: diffDays,
      };
    }

    return {
      text: end.fromNow(true) + " left",
      type: "normal",
      days: diffDays,
    };
  };

  const getActiveFiltersCount = () => {
    let count = 0;
    if (searchTerm) count++;
    if (statusFilter) count++;
    if (paymentMethodFilter) count++;
    if (startDate) count++;
    if (endDate) count++;
    if (slotFilter) count++;
    if (expiryFilter) count++;
    return count;
  };

  const buildQueryString = () => {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (paymentMethodFilter)
      params.append("paymentMethod", paymentMethodFilter);
    if (statusFilter) params.append("status", statusFilter);
    if (currentPage) params.append("page", currentPage.toString());
    if (slotFilter) params.append("slot", slotFilter);
    if (expiryFilter) params.append("expiry", expiryFilter);

    return params.toString() ? `?${params.toString()}` : "";
  };

  const handleExportExcel = () => {
    const queryString = buildQueryString();
    const url = `${baseUrl}/owner/reports/booking-report-download/${userDetails?._id}${queryString}`;

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "BookingReport.xlsx"); // name is optional; server response matters
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const selectedSlotLabel =
    slot.find((slotItem) => slotItem._id === slotFilter)?.slot_name ||
    slot.find((slotItem) => slotItem._id === slotFilter)?.slotId ||
    slotFilter;
  const activeSeatNumbers = seatMapData?.seats || [];
  const selectedSeatNumber = normalizeSeatNumber(
    seatModalBooking?.seatNo ?? seatMapData?.selectedSeatNo
  );

  return (
    <>
      <section className="main-sec">
        <div className="container-fluid">
          {/* Header */}
          <div className="row mb-4">
            <div className="col-lg-8">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faBookOpen} className="me-2" />
                  {userDetails?.libraryName}
                </h4>
              </div>
              <nav aria-label="breadcrumb" className="custom-bredcump">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Library Bookings
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          {/* Filters Card */}
          <div className="card mb-4 shadow-sm">
            <div className="card-body">
              <div className="row g-3">
                {/* Date Range */}
                <div className="col-6 col-md-3 col-lg-2">
                  <label className="form-label small text-muted">
                    Start Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>

                <div className="col-6 col-md-3 col-lg-2">
                  <label className="form-label small text-muted">
                    End Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>

                {/* Status Filter */}
                <div className="col-6 col-md-3 col-lg-2">
                  <label className="form-label small text-muted">Status</label>
                  <select
                    className="form-select"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">All Status</option>
                    <option value="pending">Pending</option>
                    <option value="confirmed">Confirmed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>

                {/* Payment Method */}
                <div className="col-6 col-md-3 col-lg-2">
                  <label className="form-label small text-muted">Payment</label>
                  <select
                    className="form-select"
                    value={paymentMethodFilter}
                    onChange={(e) => {
                      setPaymentMethodFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">All</option>
                    <option value="online">Online</option>
                    <option value="offline">Offline</option>
                  </select>
                </div>

                {/* Slot Filter */}
                <div className="col-6 col-md-3 col-lg-2">
                  <label className="form-label small text-muted">Slot</label>
                  <select
                    className="form-select"
                    value={slotFilter}
                    onChange={(e) => {
                      setSlotFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">All Slots</option>
                    {slot.map((s, idx) => (
                      <option key={idx} value={s._id}>
                        {s.slot_name || s.slotId}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Expiry Filter */}
                <div className="col-6 col-md-3 col-lg-2">
                  <label className="form-label small text-muted">
                    Expiring In
                  </label>
                  <select
                    className="form-select"
                    value={expiryFilter}
                    onChange={(e) => {
                      setExpiryFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">All</option>
                    {[1, 2, 3, 4, 5, 7, 10, 15, 30].map((d) => (
                      <option key={d} value={d}>
                        {d} day{d !== 1 ? "s" : ""}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Clear Button */}
                <div className="col-12 col-md-3 col-lg-1 d-flex align-items-end w-100">
                  <button
                    className="btn btn-outline-secondary w-100 clear_filters-btn d-flex justify-content-center align-items-center"
                    onClick={handleClearFilters}
                    disabled={getActiveFiltersCount() === 0}
                  >
                    <FontAwesomeIcon icon={faFilter} className="me-1" />
                    Clear
                  </button>
                </div>
              </div>

              {/* Active Filters */}
              {getActiveFiltersCount() > 0 && (
                <div className="active-filters mt-3">
                  <small className="text-muted me-2">
                    Active filters ({getActiveFiltersCount()}):
                  </small>
                  {searchTerm && (
                    <span className="filter-tag">Search: {searchTerm}</span>
                  )}
                  {statusFilter && (
                    <span className="filter-tag">Status: {statusFilter}</span>
                  )}
                  {paymentMethodFilter && (
                    <span className="filter-tag">
                      Payment: {paymentMethodFilter}
                    </span>
                  )}
                  {startDate && (
                    <span className="filter-tag">
                      From: {moment(startDate).format("MMM DD")}
                    </span>
                  )}
                  {endDate && (
                    <span className="filter-tag">
                      To: {moment(endDate).format("MMM DD")}
                    </span>
                  )}
                  {slotFilter && (
                    <span className="filter-tag">Slot: {selectedSlotLabel}</span>
                  )}
                  {expiryFilter && (
                    <span className="filter-tag">
                      Expiry: {expiryFilter} days
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Results Summary */}
          <div className="row mb-3">
            <div className="col-lg-6">
              <h5 className="mb-0">
                Bookings List ({bookings.length} of {totalBookings})
              </h5>
              <small className="text-muted">
                (Click Student Name for Booking Details)
              </small>
            </div>
            <div className="col-lg-6 mb-4 text-end">
              <div className="export-buttons">
                <button
                  className="btn btn-success btn-sm me-2"
                  onClick={handleExportExcel}
                >
                  <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                  Export Excel
                </button>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="card shadow-sm">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "60px" }}>SN</th>
                    <th style={{ width: "200px" }}>User Details</th>
                    <th style={{ width: "180px" }}>Period</th>
                    <th style={{ width: "150px" }}>Booking Date</th>
                    <th style={{ width: "120px" }}>Expiring In</th>
                    <th style={{ width: "120px" }}>Payment</th>
                    <th style={{ width: "90px" }}>Seat No</th>
                    <th style={{ width: "120px" }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-5">
                        <div className="d-flex flex-column align-items-center">
                          <div
                            className="spinner-border text-primary mb-3"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mb-0 fw-medium">Loading bookings...</p>
                        </div>
                      </td>
                    </tr>
                  ) : bookings.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-5">
                        <FontAwesomeIcon
                          icon={faBookOpen}
                          size="3x"
                          className="text-muted mb-3"
                        />
                        <h4>No Bookings Found!</h4>
                        <p className="text-muted">
                          {getActiveFiltersCount() > 0
                            ? "Try adjusting your search or filter criteria"
                            : "No library bookings available at the moment"}
                        </p>
                      </td>
                    </tr>
                  ) : (
                    bookings.map((booking, i) => {
                      const expiryInfo = getExpiringInText(booking.endDate);
                      return (
                        <tr key={booking._id}>
                          <td className="fw-medium">
                            {(currentPage - 1) * bookingsPerPage + i + 1}
                          </td>
                          <td>
                            <div className="user-info">
                              <div className="user-name">
                                <Link
                                  to={`/student/${booking._id}`}
                                  className="text-decoration-none"
                                >
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    className="me-1 text-primary"
                                  />
                                  {booking.userId?.name || "N/A"}
                                </Link>
                              </div>
                              <div className="user-email">
                                ID: {booking.userId?.userCode || "N/A"}
                              </div>
                              <div className="booking-id">
                                Ref: {booking.bookingId || "N/A"}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="period-info">
                              <div className="period-dates">
                                <div className="start-date">
                                  {moment(booking.startDate).format(
                                    "MMM DD, YYYY"
                                  )}
                                </div>
                                <span className="text-muted">-</span>
                                <div className="end-date">
                                  {moment(booking.endDate).format(
                                    "MMM DD, YYYY"
                                  )}
                                </div>
                                <div className="booking-time">{booking?.slotId?.slot_name}</div>
                                {/* <div className="booking-time">{booking?.fromTime}-{booking?.toTime}</div> */}
                              </div>
                              {/* <div className="time-slot">
                                {booking.fromTime} - {booking.toTime}
                              </div> */}
                            </div>
                          </td>
                          <td>
                            <div className="booking-date">
                              {/* <FontAwesomeIcon icon={faCalendarAlt} className="me-1 text-muted" /> */}
                              <div style={{ fontSize: "14px" }}>
                                {moment(booking.createdAt).format(
                                  "MMM DD, YYYY"
                                )}
                              </div>
                              <div className="booking-time">
                                {moment(booking.createdAt).format("hh:mm A")}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              className={`expiry-info expiry-${expiryInfo.type}`}
                            >
                              {expiryInfo.type === "expired" && (
                                <FontAwesomeIcon
                                  icon={faTimesCircle}
                                  className="me-1"
                                />
                              )}
                              {expiryInfo.type === "critical" && (
                                <FontAwesomeIcon
                                  icon={faExclamationTriangle}
                                  className="me-1"
                                />
                              )}
                              <span className="expiry-text text-danger">
                                {expiryInfo.text}
                              </span>
                            </div>
                          </td>
                          <td>
                            <div className="payment-info text-center">
                              {getPaymentMethodBadge(booking.paymentMethod)}
                              {booking.amount > 0 && (
                                <div className="payment-amount text-center">
                                  ₹{booking.amount}
                                </div>
                              )}
                            </div>
                          </td>
                          {/* <td className="text-center fw-medium">
                            {booking?.seatNo ?? "-"}
                          </td> */}

                          <td
                            className="text-center fw-medium"
                            style={{ width: "90px" }}
                          >
                            <button
                              type="button"
                              className={`btn btn-sm seat-trigger-btn ${normalizeSeatNumber(booking?.seatNo)
                                ? "has-seat"
                                : ""
                                }`}
                              onClick={() => handleOpenSeatModal(booking)}
                            >
                              {normalizeSeatNumber(booking?.seatNo)
                                ? `Seat ${booking.seatNo}`
                                : "Select Seat"}
                            </button>
                          </td>
                          <td>
                            {getStatusBadge(
                              booking.status,
                              booking._id,
                              booking
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination-container mt-4">
              <nav aria-label="Bookings pagination">
                <ul className="pagination justify-content-center">
                  <li
                    className={`page-item ${currentPage === 1 ? "disabled" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, index) => {
                    const pageNumber = index + 1;
                    if (
                      pageNumber === 1 ||
                      pageNumber === totalPages ||
                      (pageNumber >= currentPage - 1 &&
                        pageNumber <= currentPage + 1)
                    ) {
                      return (
                        <li
                          key={pageNumber}
                          className={`page-item ${currentPage === pageNumber ? "active" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      );
                    } else if (
                      pageNumber === currentPage - 2 ||
                      pageNumber === currentPage + 2
                    ) {
                      return (
                        <li key={pageNumber} className="page-item disabled">
                          <span className="page-link">...</span>
                        </li>
                      );
                    }
                    return null;
                  })}
                  <li
                    className={`page-item ${currentPage === totalPages ? "disabled" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => paginate(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
              <div className="text-center mt-2">
                <small className="text-muted">
                  Showing page {currentPage} of {totalPages} ({bookings.length}{" "}
                  of {totalBookings} bookings)
                </small>
              </div>
            </div>
          )}
        </div>
      </section>

      {seatModalBooking && (
        <div className="seat-modal-backdrop" onClick={handleCloseSeatModal}>
          <div
            className="seat-modal-card"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="seat-modal-header">
              <div>
                <h5 className="mb-1">Select Seat</h5>
                <p className="seat-modal-subtitle mb-0">
                  {seatModalBooking.userId?.name || "Booking"}
                  {selectedSeatNumber ? ` | Seat ${selectedSeatNumber}` : ""}
                </p>
                {seatMapData?.slot?.slot_name && (
                  <small className="seat-modal-subtitle d-block">
                    {seatMapData.slot.slot_name}
                    {seatMapData.slot.is_mearge ? " (Merged Slot)" : ""}
                  </small>
                )}
              </div>
              <button
                type="button"
                className="seat-modal-close"
                onClick={handleCloseSeatModal}
                disabled={seatSaving}
              >
                &times;
              </button>
            </div>

            <div className="seat-modal-summary">
              <span className="seat-modal-chip chip-selected">
                Selected: {selectedSeatNumber || "None"}
              </span>
              <span className="seat-modal-chip chip-occupied">
                Occupied: {seatMapData?.assignedSeats?.length || 0}
              </span>
              <span className="seat-modal-chip chip-available">
                Available: {seatMapData?.availableSeats?.length || 0}
              </span>
            </div>

            {seatMapLoading ? (
              <div className="seat-modal-loader">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : seatMapError ? (
              <div className="seat-empty-state">{seatMapError}</div>
            ) : (
              <div className="seat-grid">
                {activeSeatNumbers.map((seat) => {
                  const isSelected = selectedSeatNumber === seat.seatNo;
                  const isOccupied = seat.isAssigned && !isSelected;
                  const occupiedByLabel = Array.isArray(seat.occupiedBy?.bookedTime)
                    ? `Occupied (${seat.occupiedBy.bookedTime.join(", ")})`
                    : seat.occupiedBy?.bookedTime
                      ? `Occupied (${seat.occupiedBy.bookedTime})`
                      : seat.occupiedBy?.userName
                        ? `Assigned to ${seat.occupiedBy.userName}`
                        : "Occupied";

                  return (
                    <button
                      key={seat.seatNo}
                      type="button"
                      className={`seat-pill ${isSelected
                        ? "seat-selected"
                        : isOccupied
                          ? "seat-occupied"
                          : "seat-available"
                        }`}
                      onClick={() => handleSeatAssign(seat.seatNo)}
                      disabled={seatSaving || isOccupied}
                      title={isOccupied ? occupiedByLabel : `Assign seat ${seat.seatNo}`}
                    >
                      {seat.seatNo}
                    </button>
                  );
                })}
              </div>
            )}

            {/* <p className="seat-modal-note mb-0">
              {seatMapData?.slot?.is_mearge
                ? "Merged slot ke overlapping bookings ke hisaab se seats block ho rahi hain."
                : "Occupied seats same time/date ki active bookings se aa rahi hain."}
            </p> */}
          </div>
        </div>
      )}

      <style>
        {`
          /* Header & Summary */
          .summary-cards {
            display: flex;
            gap: 1rem;
            justify-content: flex-end;
          }

          .summary-card {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 1rem;
            border-radius: 8px;
            text-align: center;
            min-width: 140px;
          }

          .summary-value {
            font-size: 1.25rem;
            font-weight: bold;
            margin-bottom: 0.25rem;
          }

          .summary-label {
            font-size: 0.8rem;
            opacity: 0.9;
          }

          /* Filters */
          .search-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #6c757d;
            z-index: 2;
          }

          .active-filters {
            padding: 0.75rem;
            background-color: #f8f9fa;
            border-radius: 6px;
            border: 1px solid #e9ecef;
          }

          .filter-tag {
            display: inline-block;
            background: #e3f2fd;
            color: #1976d2;
            padding: 0.25rem 0.5rem;
            border-radius: 4px;
            font-size: 0.8rem;
            margin-right: 0.5rem;
            margin-bottom: 0.25rem;
          }

          /* Table Styling */
          .table {
            font-size: 0.9rem;
          }

          .table th {
            font-weight: 600;
            color: #495057;
            border-bottom: 2px solid #dee2e6;
            padding: 1rem 0.75rem;
          }

          .table td {
            padding: 1rem 0.75rem;
            vertical-align: middle;
          }

          .table tbody tr:hover {
            background-color: #f8f9fa;
          }

          /* User Info */
          .user-info {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
          }

          .user-name {
            font-weight: 600;
            color: #495057;
          }

          .user-name a {
            color: #0d6efd;
          }

          .user-name a:hover {
            color: #0a58ca;
          }

          .user-email {
            font-size: 0.8rem;
            color: #6c757d;
          }

          .booking-id {
            font-size: 0.75rem;
            color: #6c757d;
            font-family: monospace;
          }

          /* Period Info */
          .period-info {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
          }

          .period-dates {
            display: flex;
            flex-direction: column;
            gap: 0.125rem;
          }

          .start-date, .end-date {
            font-weight: 500;
            font-size: 0.85rem;
          }

          .date-separator {
            font-size: 0.75rem;
            color: #6c757d;
            text-align: center;
          }

          .time-slot {
            background: #e3f2fd;
            color: #1976d2;
            padding: 0.25rem 0.5rem;
            border-radius: 4px;
            font-size: 0.75rem;
            text-align: center;
            font-weight: 500;
          }

          /* Booking Date */
          .booking-date {
            display: flex;
            flex-direction: column;
            gap: 0.125rem;
            align-items: flex-start;
          }

          .booking-time {
            font-size: 0.75rem;
            color: #6c757d;
          }

          /* Expiry Info */
          .expiry-info {
            display: flex;
            align-items: center;
            gap: 0.25rem;
            font-weight: 500;
            font-size: 0.85rem;
          }

          .expiry-expired {
            color: #dc3545;
          }

          .expiry-critical {
            color: #fd7e14;
          }

          .expiry-warning {
            color: #ffc107;
          }

          .expiry-normal {
            color: #28a745;
          }

          /* Payment Info */
          .payment-info {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
          }

          .payment-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
            padding: 0.25rem 0.5rem;
            border-radius: 4px;
            font-size: 0.75rem;
            font-weight: 500;
          }

          .payment-online {
            background: #e3f2fd;
            color: #1976d2;
          }

          .payment-offline {
            background: #f3e5f5;
            color: #7b1fa2;
          }

          .payment-amount {
            font-size: 0.8rem;
            font-weight: 600;
            color: #28a745;
          }

          /* Status Badge */
          .status-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
            padding: 0.375rem 0.75rem;
            border-radius: 6px;
            font-size: 0.8rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            border: none;
            text-decoration: none;
          }

          .status-badge:hover {
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }

          .status-warning {
            background: #fff3cd;
            color: #856404;
            border: 1px solid #ffeaa7;
          }

          .status-success {
            background: #d1edff;
            color: #0f5132;
            border: 1px solid #a3cfbb;
          }

          .status-danger {
            background: #f8d7da;
            color: #721c24;
            border: 1px solid #f1aeb5;
          }

          .status-text {
            font-weight: 500;
          }

          /* Dropdown */
          .dropdown-menu {
            border: 1px solid #dee2e6;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            border-radius: 6px;
          }

          .dropdown-item {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
          }

          .dropdown-item:hover {
            background-color: #f8f9fa;
          }

          /* Seat Picker */
          .seat-trigger-btn {
            min-width: 86px;
            border-radius: 999px;
            border: 1px solid #cfd8dc;
            background: #ffffff;
            color: #1f2933;
            font-weight: 600;
          }

          .seat-trigger-btn.has-seat {
            border-color: #1f7a5a;
            background: #e8fff5;
            color: #146c43;
          }

          .seat-modal-backdrop {
            position: fixed;
            inset: 0;
            z-index: 1050;
            background: rgba(15, 23, 42, 0.55);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1rem;
          }

          .seat-modal-card {
            width: min(720px, 100%);
            max-height: 90vh;
            overflow-y: auto;
            background: #ffffff;
            border-radius: 20px;
            padding: 1.25rem;
            box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
          }

          .seat-modal-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 1rem;
            margin-bottom: 1rem;
          }

          .seat-modal-subtitle {
            color: #64748b;
            font-size: 0.92rem;
          }

          .seat-modal-close {
            width: 36px;
            height: 36px;
            border: none;
            border-radius: 50%;
            background: #f1f5f9;
            color: #0f172a;
            font-size: 1.5rem;
            line-height: 1;
          }

          .seat-modal-summary {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin-bottom: 1rem;
          }

          .seat-modal-chip {
            display: inline-flex;
            align-items: center;
            padding: 0.45rem 0.8rem;
            border-radius: 999px;
            font-size: 0.82rem;
            font-weight: 600;
          }

          .chip-selected {
            background: #dbeafe;
            color: #1d4ed8;
          }

          .chip-occupied {
            background: #fee2e2;
            color: #b91c1c;
          }

          .chip-available {
            background: #dcfce7;
            color: #15803d;
          }

          .seat-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(62px, 1fr));
            gap: 0.75rem;
          }

          .seat-modal-loader,
          .seat-empty-state {
            min-height: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            color: #64748b;
            font-weight: 500;
          }

          .seat-pill {
            width: 62px;
            height: 62px;
            border-radius: 50%;
            border: 1px solid transparent;
            font-weight: 700;
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }

          .seat-pill:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 10px 18px rgba(15, 23, 42, 0.14);
          }

          .seat-available {
            background: #eff6ff;
            border-color: #bfdbfe;
            color: #1d4ed8;
          }

          .seat-selected {
            background: #16a34a;
            border-color: #15803d;
            color: #ffffff;
          }

          .seat-occupied {
            background: #fecaca;
            border-color: #f87171;
            color: #991b1b;
            cursor: not-allowed;
          }

          .seat-pill:disabled {
            opacity: 1;
          }

          .seat-modal-note {
            margin-top: 1rem;
            color: #64748b;
            font-size: 0.85rem;
          }

          /* Responsive Design */
          @media (max-width: 1200px) {
            .summary-cards {
              justify-content: center;
              margin-top: 1rem;
            }
          }

          @media (max-width: 768px) {
            .table {
              font-size: 0.8rem;
            }
            
            .table th,
            .table td {
              padding: 0.5rem 0.25rem;
            }

            .user-info,
            .period-info,
            .payment-info {
              font-size: 0.8rem;
            }

            .status-badge {
              padding: 0.25rem 0.5rem;
              font-size: 0.7rem;
            }

            .payment-badge {
              font-size: 0.7rem;
              padding: 0.2rem 0.4rem;
            }

            .time-slot {
              font-size: 0.7rem;
              padding: 0.2rem 0.4rem;
            }

            .seat-modal-card {
              padding: 1rem;
            }

            .seat-grid {
              grid-template-columns: repeat(auto-fill, minmax(54px, 1fr));
              gap: 0.5rem;
            }

            .seat-pill {
              width: 54px;
              height: 54px;
              font-size: 0.82rem;
            }
          }

          /* Loading and Empty States */
          .spinner-border {
            width: 3rem;
            height: 3rem;
          }

          /* Pagination */
          .pagination-container {
            border-top: 1px solid #dee2e6;
            padding-top: 1rem;
          }

          .page-link {
            color: #0d6efd;
            border-color: #dee2e6;
          }

          .page-item.active .page-link {
            background-color: #0d6efd;
            border-color: #0d6efd;
          }
        `}
      </style>
    </>
  );
}


